/*global setTimeout setInterval clearInterval*/
import React from 'react'

const REVEAL_DELAYS = [5000, 10000, 15000, 20000]
const SPIN_INTERVAL = 80

class MirrorSlotNumber extends React.Component {
  state = {
    display: ['0', '0', '0', '0'],
    active: [false, false, false, false],
  }

  componentDidMount() {
    this._intervals = REVEAL_DELAYS.map((delay, index) =>
      setInterval(() => {
        this.setState(prev => {
          const display = [...prev.display]
          display[index] = String(Math.floor(Math.random() * 10))
          return { display }
        })
      }, SPIN_INTERVAL)
    )
    REVEAL_DELAYS.forEach((delay, index) => {
      setTimeout(() => {
        clearInterval(this._intervals[index])
        this.setState(prev => {
          const display = [...prev.display]
          const active = [...prev.active]
          display[index] = this.props.number[index]
          active[index] = true
          return { display, active }
        })
      }, delay)
    })
  }

  componentWillUnmount() {
    this._intervals.forEach(clearInterval)
  }

  render() {
    const { display, active } = this.state
    return (
      <div className="slots-row">
        {display.map((digit, index) => (
          <div key={index} className={`number-box ${active[index] ? 'active-number' : ''}`}>
            {digit}
          </div>
        ))}
      </div>
    )
  }
}

export default MirrorSlotNumber
